import React from 'react';
import Home from '../../pages/home';
import Cooking from '../../pages/cooking';
import Movies from '../../pages/movies';
import Notes from '../../pages/notes';
import {TodoList} from '../../pages/todoList';
import Questions from '../../pages/questions';
import Calendar from '../../pages/calendar';
import CreativeSpace from '../../pages/creativeSpace';
import Profil from '../../components/logInUserInformation/profil';

const DashboardContent = ({ selectedSidebarItem, selectedHeaderItem }) => {
    if (selectedSidebarItem === 'Home') {
        return <Home />;
    } else if (selectedHeaderItem === 'Cooking') {
        return <Cooking />;
    } else if (selectedHeaderItem === 'Movies') {
        return <Movies />;
    } else if (selectedHeaderItem === 'Notes') {
        return <Notes />;
    } else if (selectedHeaderItem === 'ToDo List') {
        return <TodoList />;
    } else if (selectedHeaderItem === 'Questions') {
        return <Questions />;
    } else if (selectedHeaderItem === 'Calendar') {
        return <Calendar />;
    } else if (selectedHeaderItem === 'Menstrual tracker') {
        return <CreativeSpace />;
    } else if (selectedHeaderItem === 'Profil') {
        return <Profil />;
    }

    return <Home />;
};

export default React.memo(DashboardContent);
